import api from './index'

let exports = {};
// 获取指定工单的金额总和
exports.getWorkVoucherAmountByIds = function (data, callback) {// 获取指定工单的金额总和
    api.post('/servcDeliv/work/voucher/amount/get/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getServcWorkVoucherList = function (data, callback) {// 通过服务订单id获取服务工单列表
    api.post('/servcDeliv/servc/work/voucher/list/get/by/orderId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveServcWorkVoucherForExport = function (data, callback) {// 获取服务工单列表
    api.post('/servcDeliv/servc/work/voucher/list/params/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcWorkVoucherPageList = function (data, callback) {// 通过服务订单id获取服务工单列表
    api.post('/servcDeliv/servc/work/voucher/paged/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServcWorkVoucherByMasterIdList = function (data, callback) {// 通过服务订单id获取服务工单列表
    api.post('/servcDeliv/servc/work/voucher/paged/list/get/by/masterId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcWorkVoucherRetailerTagList = function (data, callback) {// 通过服务订单结算标签列表
    api.post('/servcDeliv/servc/work/voucher/retailerTag/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getServcWorkVoucherDetail = function (params, callback) {// 通过服务工单id获取服务工单详情
    api.get('/servcDeliv/servc/work/voucher/detail/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServcWorkVoucherInfo = function (params, callback) {// 通过服务工单no获取服务工单详情
    api.get('/servcDeliv/servc/work/voucher/info/get/by/no')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getServcWorkVoucherByTmpNo = function (data, callback) {// 根据tmpNo获取工单列表 - 【维保记录】
    api.post('/servcDeliv/servc/work/voucher/list/get/by/tmpNo')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServcWorkVouchersByPlanId = function (data, callback) {// 根据planId获取工单列表 - 【检验记录】
    api.post('/servcDeliv/servc/work/voucher/list/get/by/planId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDeviceInspectRecExportParams = function (data, callback) {// 【检验记录】 -- 导出参数
    api.post('/servcDeliv/device/inspect/rec/export/params/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServcRepaireMaintForExport = function (data, callback) {// 【维保记录】 -- 导出
    api.post('/servcDeliv/servc/repaire/main/export/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getServcOrderChargeItemListByWorkVoucherId = function (params, callback) {// 通过工单id获取服务订单收费项
    api.get('/servcDeliv/servc/work/charge/item/list/get/by/workVoucherId')
    .params(params)
    .done(callback)
    .go();
};
exports.getServcWorkVoucherListBySvcSubNoOrDeviceId = function (data, callback) {// 通过工单id获取服务订单收费项列表
    api.post('/servcDeliv/servc/work/voucher/list/get/by/svcSubNo/or/deviceId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getGoodsCatServicerStatisList = function (data, callback) {// 设备分类服务商服务统计报表
    api.post('/servcDeliv/goodsCat/servicer/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getGoodsCatVendorFulfillStatisList = function (data, callback) {// 设备分类供应商履约率统计报表
    api.post('/servcDeliv/goodsCat/vendor/fulfill/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getGoodsCatVendorPSQMStatisList = function (data, callback) {// 供应商客观评价数据统计
    api.post('/servcDeliv/goodsCat/vendor/psqm/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getGoodsCatServicerFulfillStatisList = function (data, callback) {// 设备分类供应商履约率统计报表
    api.post('/servcDeliv/goodsCat/servicer/fulfill/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServicerPSQMStatisList = function (data, callback) {// 设备分类供应商履约率统计报表
    api.post('/servcDeliv/servicer/psqm/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcWorkDevicePartDocList = function (data, callback) {// ES获取部件维修明细列表
    api.post('/servcDeliv/servc/work/device/part/doc/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcWorkVoucherRecListByWorkVoucherId = function (params, callback) {// 通过工单id获取服务工单操作记录
    api.get('/servcDeliv/servc/work/voucher/rec/list/get/by/workVoucherId')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 保存服务评价
exports.getOrderServcEvalList = function (data, callback) {
    api.post('/servcDeliv/order/servc/eval/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 评价详细信息
exports.getOrderServcEvalInfo = function (params, callback) {// 查询评价信息
    api.post('/servcDeliv/eval/info/get')
    .data(params)
    .done(callback)
    .go();
};
// 保存服务评价
exports.saveOrderServcEval = function (data, callback) {
    api.post('/servcDeliv/order/servc/eval/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 通过工单id获取订单项
exports.getServcOrderItemByServcWorkVoucherId = function (params, callback) {// 通过服务工单id获取服务工单详情
    api.get('/servcDeliv/servc/order/item/by/workId/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 确认完成-批量执行
exports.doBatchConfirmCompleted = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/check/batch/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 批量执行
exports.doBatchRetailerTag = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/retailerTag/batch/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 处理违约
exports.doHandleServcWorkVoucherViolate = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/violate/handle/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ------------------------------ 保养记录单 -------------------------
exports.getDevcMaintVoucherList = function (data, callback) {
    api.post('/servcDeliv/devc/maint/voucher/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getDevcInspectInfoList = function (data, callback) {
    api.post('/servcDeliv/devc/inspect/info/list')
    .data(data)
    .done(callback)
    .go();
};
//
// 设备保养信息
exports.getDevcMaintInfo = function (params, callback) {
    api.get('/servcDeliv/devc/maint/info/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备检验信息
exports.getDevcInspectInfo = function (params, callback) {
    api.get('/servcDeliv/devc/inspect/info/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 查询工单人员要求资质
exports.getServcWorkStaffQualiListByVoucherId = function (data, callback) {
    api.post('/servcDeliv/servc/work/staff/quali/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 作废
exports.invalidatedServcWorkVoucher = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/invalidated/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 服务工单补配件
exports.saveServcWorkShareAccItemList = function (data, callback) {
    api.post('/servcDeliv/servc/work/share/acc/item/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 零售商创建安装工单
exports.saveServcWorkVoucherForSetup = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/setup/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 零售商直接下工单
exports.saveServcWorkVoucherProxied = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveServcReqVoucher = function (data, callback) {
    api.post('/servcDispt/servc/req/voucher/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServcWorkVoucherById = function (params, callback) {
    api.get('/servcDeliv/servc/work/voucher/info/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServcWorkAddItemList = function (params, callback) {
    api.get('/servcDeliv/servc/work/add/item/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveServcWorkImgFile = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServcWorkImgFileById = function (data, callback) {
    api.get('/servcDeliv/servc/work/img/file/get/by/id')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.deleteServcWorkImgFile = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/delete')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateServcWorkImgFile = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/update')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateSharedServcWorkImgFile = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/shared/update')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getMaxWorkAttachFileCount = function (params, callback) {
    api.get('/servcDeliv/max/work/attach/file/count/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcWorkImgFileListByVoucherId = function (params, callback) {
    api.get('/servcDeliv/servc/work/img/file/get/by/voucherId')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServcWorkImgFileList = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServcWorkImgFileListByFilter = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/get/by/filter')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateServcWorkImgFileTagName = function (postData, callback) {
    api.post('/servcDeliv/servc/work/img/file/update/tagName')
    .data(postData)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDevcMaintVoucherById = function (params, callback) {
    api.get('/servcDeliv/devc/maint/voucher/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDeviceServcRecDtoList = function (data, callback) {
    api.post('/servcDeliv/device/servc/rec/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getCheckWorkVoucherList = function (data, callback) {
    api.post('/servcDeliv/check/work/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getCheckWorkVoucherByRefSrcId = function (data, callback) {
    api.get('/servcDeliv/check/work/voucher')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateServcWorkVoucherInvain = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/invain/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doServcWorkVoucherViolated = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/violated/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doServcWorkVoucherExpiatoryCreate = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/expiatory/create/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// ====================== 内部工单 ==============================

// 内部工单列表查询
exports.getInnerWorkVoucherList = function (data, callback) {
    api.post('/servcDeliv/inner/work/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 内部工单详情
exports.getInnerWorkVoucherInfo = function (params, callback) {
    api.get('/servcDeliv/inner/work/voucher/info/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 更换内部工单负责人
exports.doChangeInnerWorkVoucherSvcStaff = function (data, callback) {
    api.post('/servcDeliv/inner/work/voucher/svcStaff/change/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 作废内部工单
exports.doInvalidInnerWorkVoucher = function (data, callback) {
    api.post('/servcDeliv/inner/work/voucher/invalid/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 附件列表
exports.getInnerWorkImgList = function (data, callback) {
    api.post('/servcDeliv/inner/work/img/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 附件批量保存
exports.saveInnerWorkImgList = function (data, callback) {
    api.post('/servcDeliv/inner/work/img/list/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 修改附件标题
exports.updateInnerWorkImgImgTitle = function (data, callback) {
    api.post('/servcDeliv/inner/work/img/imgTitle/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 附件删除
exports.doDeleteInnerWorkImg = function (data, callback) {
    api.post('/servcDeliv/inner/work/img/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servcDeliv.js
// module id = 34
// module chunks = 0